'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./MyPlaylistTracks.scss');

var MyPlaylistTrackName = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(MyPlaylistTrackName, _PureComponent);

  function MyPlaylistTrackName() {
    (0, _classCallCheck3.default)(this, MyPlaylistTrackName);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTrackName.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTrackName)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistTrackName, [{
    key: 'render',
    value: function render() {
      var track = this.props.track;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          track.trackName
        ),
        track.albumArtist && _react2.default.createElement(
          'span',
          { className: styles.trackArtist },
          track.albumArtist
        )
      );
    }
  }]);
  return MyPlaylistTrackName;
}(_react.PureComponent), _class.propTypes = {
  track: _propTypes2.default.object
}, _class.defaultProps = {
  track: {}
}, _temp);
exports.default = MyPlaylistTrackName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/MyPlaylistTrackName.js
// module id = 2166
// module chunks = 1